import { combineReducers } from "redux";

import authenticationReducer from "features/application/authentication/redux/reducer";
import formReducer from "features/application/form/redux/reducer";
import fieldReducer from "features/application/field/redux/reducer";
import loaderReducer from "features/application/loader/redux/reducer";
import { sharedEventsReducer } from "features/shared-event/redux/reducer";
import { friendReferReducer } from "features/friend-refer/redux/reducer";

const reducer = combineReducers({
  authenticationReducer,
  formReducer,
  fieldReducer,
  loaderReducer,
  sharedEventsReducer,
  friendReferReducer,
});

export default reducer;
